// Lexicographic-order "head before neighbor" key generator.
// Mirrors the server-side Lex.head behavior used for fractional positions.

export function headPosition(neighborTop: string | null): string {
  if (neighborTop === null) return "a0";
  // If the neighbor is already at or below "a", prepend "0" to sort before it.
  if (neighborTop <= "a") return "0" + neighborTop;
  // Otherwise "a" sorts before any neighbor that starts with a letter > "a".
  return "a";
}
